import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.scss";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function Login() {
  const navigate = useNavigate();
  const [userObj, setUserObj] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  // Api starts here
  // const submit = async () => {
  //     let formData = { ...userObj };
  //     formData.password = formData.password.toLowerCase();
  //     console.log("formData",formData);
  //     if (!formData.username) {
  //       Swal.fire({
  //         text: "Please enter your mobile number.",
  //         icon: "warning",
  //         showConfirmButton: false,
  //         heightAuto: false,
  //         timer: 1500,
  //       });
  //     }
  //     else if (!formData.password) {
  //       Swal.fire({
  //         text: "Please enter password.",
  //         icon: "warning",
  //         showConfirmButton: false,
  //         heightAuto: false,
  //         timer: 1500,
  //       });
  //     }
  //     else {
  //       let loginData = await loginApi(formData);
  //       if (loginData.status === "S") {
  //         localStorage.setItem("userData", JSON.stringify(loginData));
  //         console.log(loginData);
  //         // localStorage.setItem("token", loginData.token);
  //         localStorage.setItem("role_id", JSON.stringify(loginData.role_id));
  //         localStorage.setItem("correl_id", loginData.correl_id);
  //         if (loginData.is_profile_updated === "N") {
  //           navigate("/set-profile");
  //           return;
  //         } else if (
  //           loginData.is_first_time_login === "Y"
  //         ) {
  //           navigate("/set-password");
  //           return;
  //         } else if(loginData.is_first_time_login === "N"){

  //           navigate("/home");
  //           return;
  //         }
  //         else {
  //           navigate("/home");
  //           return;
  //         }
  //       } else if (loginData.status === "E") {
  //         Swal.fire({
  //           text: loginData.message,
  //           showConfirmButton: false,
  //           icon: "warning",
  //           timer: 3000,
  //         });
  //         return;
  //       } else if (loginData.error_status === "F") {
  //         Swal.fire({
  //           text:
  //             loginData.status === "E"
  //               ? loginData.errorDescription
  //                 ? loginData.errorDescription
  //                 : "Something went wrong"
  //               : "Something went wrong",
  //           showConfirmButton: false,
  //           icon: "warning",
  //           timer: 3000,
  //         });
  //         return;
  //       }
  //     }
  // }

  return (
    <div className="loginContainer login-page">
      <div className="row g-0 h-100 w-100">
        <div className="col-6">
          <div className="loginLeft d-none d-lg-flex">
            <h5 className="headingText">
              <strong>Welcome to UpwardIQ!</strong>
            </h5>
            <img
              src={require("../../assets/image.png")}
              alt="RECUPE"
              className="vec-image"
            />
            {/* <p>Software for Child Development Center that allows <br className='d-none d-lg-block' /> therapy center owners to streamline and automate their business process</p> */}
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat
              eius sint officia laboriosam perferendis omnis nulla incidunt
              animi nobis tempora!
            </p>
            {/* <p>Developed by <a href="https://impaxivesolutions.com" className='text-danger text-decoration-none' target='_blank' rel="noreferrer">Impaxive Solutions</a></p> */}
          </div>
        </div>
        <div className="col-12 col-lg-6 h-100">
          <div className="loginRight h-100">
            <h5 className="loginText">Login to your Account</h5>
            <TextField
              id="emailInput"
              label="Mobile Number *"
              variant="outlined"
              className="mb-1 cust-white-input-field"
              autoComplete="off"
              value={userObj.username}
              onChange={(ev) => {
                const input = ev.target.value;
                // Regular expression to block specific patterns
                const disallowedPattern =
                  /<script.*?>.*?<\/script>|<.*?>|[<>/:?\]|"',;]/i;

                // Allow input only if it doesn't match the pattern
                if (!disallowedPattern.test(input)) {
                  setUserObj({ ...userObj, username: input });
                }
              }}
            />

            <TextField
              id="outlined-basic"
              label="Password *"
              variant="outlined"
              className="mb-1 cust-white-input-field"
              autoComplete="off"
              type={showPassword ? "text" : "password"}
              value={userObj.password}
              inputProps={{ minLength: 8, maxLength: 16 }}
              onChange={(ev) => {
                const input = ev.target.value;
                const allowedPattern = /^[a-zA-Z0-9.@_\-\s]*$/;
                // Allow input only if it matches the allowed pattern
                if (allowedPattern.test(input)) {
                  setUserObj({
                    ...userObj,
                    password: input,
                  });
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="text-white"
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShowPassword(!showPassword);
                      }}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onKeyDown={(ev) => {
                if (ev.key === "Enter") {
                  ev.preventDefault();
                  navigate("/");
                }
              }}
            />
            <div className="mt-4">
              <button
                className="btn btn-white rounded-pill text-uppercase"
                onClick={() => {
                  navigate("/");
                }}
              >
                Login
              </button>
            </div>
            <div className="text-center mt-2">
              <button
                className="btn btn-light-black"
                onClick={() => {
                  navigate("/forgot-password");
                }}
              >
                Forgot Password?
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
